// extracted by mini-css-extract-plugin
export default {"wrapper":"automation_wrapper__qTKl7","inputWrapper":"automation_inputWrapper__Vu0MS"};